<template>
    <div class="w-full">
        <div class="analysis gap-2">
            <div class="flex flex-col bg-background-80 py-[7px] px-[10px] rounded-lg items-center justify-around col-span-1">
                <div class="text-grey-40 text-xs font-medium mb-[5px]">
                    {{$t('niuniu.hallType')}}
                </div>
                <div class="inline-flex text-sm gap-1">
                    <em class="quantity">
                        <IconSvgUse use="icon-cow-blue" class="w-[34px] h-[20px] duration-100" />
                                        
                        <div class="ml-[4px] text-[14px] font-[800] leading-[14px]">{{ getHallName(history.hall_name) }}({{ history.rate_type }})</div>
                    </em>
                </div>
            </div>
            <div class="flex flex-col bg-background-80 py-[7px] px-[10px] rounded-lg items-center justify-around col-span-1">
                <div class="text-grey-40 text-xs font-medium mb-[5px]">
                    {{ $t('niuniu.betAmount') }}
                </div>
                <!-- ↓ 这里的倍数保留了2位，原版即保留了2位。2024.04.30 10:16:35 星期二  -->
                <div class="inline-flex text-sm font-semibold"
                    :class="[history.winAmount ? 'text-[#1BB83D]' : 'text-white']"
                >
                   {{history.baseAmount}}
                </div>
            </div>
        </div>

        <div class="analysis gap-2">
            <div class="flex flex-col bg-background-80 py-[7px] px-[10px] rounded-lg items-center justify-around col-span-1">
                <div class="text-grey-40 text-xs font-medium mb-[5px]">
                    {{$t('niuniu.payout')}}
                </div>
                <div class="inline-flex text-sm gap-1">
                    <CurrentCoin :name="history.currency" />
                    <div class="font-semibold"
                        :class="history.winAmount > 0 ? 'text-[#1BB83D]' : 'text-white'"
                    >
                        <template v-if="history.winAmount - history.amount > 0">+{{ (Number(history.winAmount) - Number(history.amount)).toFixed(2) }}</template>
                        <template v-else-if="history.winAmount - history.amount < 0">-{{ Math.abs(history.winAmount - history.amount).toFixed(2) }}</template>
                        <template v-else>0.00</template>
                    </div>
                </div>
            </div>
        </div>

        <div class="big-list gray-box">
            <q-table :pagination="{ rowsPerPage: 100 }" hide-pagination row-key="name"
                :no-data-label="$t('Noinformation')" :rows="tableArr" :columns="oActiveTable.aColumns"
                table-class="big-table">
                <template v-slot:body="props">
                    <!-- 庄家行 -->
                    <q-tr :props="props">
                        <q-td class="td-area" key="area">
                            <div class="area-info">
                                <div class="text-[12px] font-[600] leading-[12px] text-white">{{ $t('niuniu.banker') }}</div>
                            </div>
                        </q-td>
                        
                        <q-td key="cards" class="cards-column">
                            <div class="cards-row-compact">
                                <PokerCard v-for="(card, index) in sortCardsForNiu(props.row.bankerCards)" :key="index" 
                                :class="{
                                    'pocker-img0': index === 0,
                                    'pocker-img1': index === 1,
                                    'pocker-img2': index === 2,
                                    'pocker-img3': index === 3,
                                    'pocker-img4': index === 4,
                                    'rules-face-up': true,
                                    'niu-card-raised': index < 3 && hasNiu(props.row.bankerCards)
                                }" :card="card"
                                width="40px" height="40px" :isFaceUpProp="true" />
                            </div>
                        </q-td>
                        <q-td class="td-profit" key="result">
                            <div class="text-[14px] font-[700] leading-[14px]" :class="props.row.banker_niu_type === 0 ? 'text-[#93ACD3]' : 'text-white'">{{ getNiuTypeName(props.row.banker_niu_type) }}</div>
                            <div v-if="parsedSector?.BankerMulti" class="text-[14px] font-[700] leading-[14px] tracking-[0.2px] text-[#1BB83D] mt-[5px]">×{{ parsedSector.BankerMulti }}</div>
                        </q-td>
                    </q-tr>

                    <!-- 显示所有区域（天地玄黄）- 不管是否赢 -->
                    <template v-for="sector in ['tian', 'di', 'xuan', 'huang']" :key="`area-${props.row.id}-${sector}`">
                        <q-tr :props="props" :class="{ 'winning-row': isWinningSector(props.row, sector), 'last-sector-row': sector === 'huang' }">
                            <q-td class="area" key="area">
                                <div class="text-[12px] font-[600] leading-[12px] text-white">{{ getAreaDisplayName(sector) }}</div>
                                <div v-if="isWinningSector(props.row, sector)" class="text-[11px] leading-[11px] text-[#1BB83D] mt-[2px]">{{$t('niuniu.win')}} </div>
                                <div v-else-if="isLosingSector(props.row, sector)" class="text-[11px] leading-[11px] text-[#93ACD3] mt-[2px]">{{$t('niuniu.lose')}} </div>
                            </q-td>
                            
                            <q-td key="cards" class="cards-column">
                                <div class="cards-row-compact">
                                        <PokerCard v-for="(card, index) in sortCardsForNiu(getCardsForSector(props.row, sector))" :key="index" 
                                        :class="{
                                            'pocker-img0': index === 0,
                                            'pocker-img1': index === 1,
                                            'pocker-img2': index === 2,
                                            'pocker-img3': index === 3,
                                            'pocker-img4': index === 4,
                                            'rules-face-up': true,
                                            'niu-card-raised': index < 3 && hasNiu(getCardsForSector(props.row, sector))
                                        }" :card="card"
                                        width="40px" height="40px" :isFaceUpProp="true" />
                                </div>
                            </q-td>
                            <q-td class="td-profit" key="result">
                                <div class="text-[14px] font-[700] leading-[14px]" :class="getNiuTypeForSector(props.row, sector) === 0 ? 'text-[#93ACD3]' : 'text-white'">
                                    <span>{{ getNiuTypeName(getNiuTypeForSector(props.row, sector)) }}</span>
                                </div>
                                <div v-if="getMultiplierForSector(sector)" 
                                     class="text-[14px] font-[700] leading-[14px] tracking-[0.2px] text-[#1BB83D] mt-[5px]">
                                    ×{{ getMultiplierForSector(sector) }}
                                </div>
                            </q-td>
                        </q-tr>
                    </template>
                </template>
                <template v-slot:no-data="{ message }">
                    <img class="no-data-pic" src="@/assets/imgs/no-data.webp" />
                    <p class="no-data-message">
                        {{ message }}
                    </p>
                </template>
            </q-table>
        </div>

        <div class="big-list gray-box mt-[15px]">
            <div class="text-[12px] text-[#55657E] font-[500px] leading-[12px] pb-[8px]" style="border-bottom: 1px solid var(--bet-corgi-color-white-12, #FFFFFF1F)">{{ $t('niuniu.bettingArea') }}</div>
            <div class="flex pt-[14px]">
                <div class="w-[25%] flex items-center" 
                     :class="areaIndex === 0 ? 'justify-start' : areaIndex === 3 ? 'justify-end' : 'justify-center'" 
                     v-for="(area,areaIndex) in bettingArea" 
                     :key="area.id">
                    <span class="text-[12px] text-[#93ACD3] font-[600] leading-[12px]">{{area.name}}</span>
                    <span class="text-[14px] text-white font-[700] leading-[14px] ml-[5px]">{{area.amount}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import PokerCard from '~/pages/casino/niuniuGame/_components/PokerCard.vue';
import { getTables } from '~/pages/casino/niuniuGame/ts/niuniuCommon';
import { getCardsDetailFromIds } from '~/pages/casino/niuniuGame/ts/cardConstants';

const props = defineProps({
    modelValue: Boolean, //
    backdrop: {
        type: Boolean,
        default: true,
    },
    history: {
        type: Object,
        default: () => ({}),
    },
});
const { t: $tFn, locale } = useNuxtApp().$i18n;

const tables = ref([])
tables.value = getTables()

// 缓存区域配置映射（避免重复计算）
const areaConfigMap = computed(() => {
    const map: Record<string, { index: number; name: string; nameCn: string; multiField: string }> = {};
    if (tables.value && tables.value.length > 0) {
        tables.value.forEach((table, index) => {
            const areaName = table.name; // 'tian', 'di', 'xuan', 'huang'
            const multiFieldName = areaName.charAt(0).toUpperCase() + areaName.slice(1) + 'Multi';
            map[areaName] = {
                index,
                name: table.name,
                nameCn: table.nameCn,
                multiField: multiFieldName
            };
        });
    }
    return map;
});

// 区域列表（按顺序）
const areaList = computed(() => ['tian', 'di', 'xuan', 'huang']);

// 获取房间名称的翻译
const getHallName = (hallName) => {
    const hallMap = {
        'trial': $tFn('niuniu.hall01'),
        'casual': $tFn('niuniu.hall02'),
        'premium': $tFn('niuniu.hall03')
    };
    return hallMap[hallName] || hallName;
};

const obj01 = { field: '', name: '', label: '' };
const oActiveTable = reactive({
    aColumns: [{ ...obj01, label: $tFn('goldenFlower.result') }, obj01, obj01],
});
// 缓存解析后的 sector 数据，避免重复解析
const parsedSector = computed(() => {
    if (!props.history?.sector) return null;
    try {
        return JSON.parse(props.history.sector);
    } catch (error) {
        console.error('❌ [历史详情] 解析 sector JSON 失败:', error);
        return null;
    }
});

// 计算投注区域数据（金额和倍率都从 sector 字段获取）
const bettingArea = computed(() => {
    const sectorData = parsedSector.value;
    
    return areaList.value.map(areaId => {
        const config = areaConfigMap.value[areaId];
        if (!config) return null;
        
        const amountField = areaId.charAt(0).toUpperCase() + areaId.slice(1); // Tian, Di, Xuan, Huang
        const multiplierField = amountField + 'Multi'; // TianMulti, DiMulti, XuanMulti, HuangMulti
        
        return {
            id: areaId,
            name: locale.value === 'cn' ? config.nameCn : config.name,
            amount: sectorData ? Number(sectorData[amountField] || 0) : 0,
            multiplier: sectorData ? String(sectorData[multiplierField] || '1') : '1'
        };
    }).filter(Boolean);
})

// 主表数据
const tableArr = computed(() => {
    const roundData = props.history?.round || [];
    return roundData.map(item => {
        return {
            ...item,
            name: item.id, // 用于row-key
            // 解析牌数据：先用 parseCards 转为 ID 数组，再用 getCardsDetailFromIds 获取完整信息
            bankerCards: getCardsDetailFromIds(parseCards(item.banker_cards)),
            tianCards: getCardsDetailFromIds(parseCards(item.tian_cards)),
            diCards: getCardsDetailFromIds(parseCards(item.di_cards)),
            xuanCards: getCardsDetailFromIds(parseCards(item.xuan_cards)),
            huangCards: getCardsDetailFromIds(parseCards(item.huang_cards)),
            winningSectors: parseWinningSectors(item.winning_sectors)
        };
    });
});
// 解析卡牌ID字符串为数字数组
function parseCards(cardsStr) {
    if (!cardsStr) return [];
    return cardsStr.split(',').map(id => parseInt(id.trim()));
}

// 解析赢的区域
function parseWinningSectors(sectorsStr) {
    if (!sectorsStr) return [];
    try {
        return JSON.parse(sectorsStr);
    } catch (e) {
        return [];
    }
}

// 获取牛牛牌型名称
function getNiuTypeName(niuType) {
    // 使用i18n系统获取牌型名称
    if (niuType >= 0 && niuType <= 13) {
        return $tFn(`niuniu.niuType${niuType}`);
    }
    return $tFn('niuniu.unknownType');
}

// 获取区域的显示名称（使用缓存的配置）
function getAreaDisplayName(area: string): string {
    const config = areaConfigMap.value[area];
    if (!config) return area;
    return locale.value === 'cn' ? config.nameCn : config.name;
}

// 获取指定区域的倍率（从 parsedSector）
function getMultiplierForSector(sector: string): string | null {
    if (!parsedSector.value) return null;
    
    // 区域名称映射到倍率字段：tian -> TianMulti, di -> DiMulti, xuan -> XuanMulti, huang -> HuangMulti
    const multiplierField = sector.charAt(0).toUpperCase() + sector.slice(1) + 'Multi';
    return parsedSector.value[multiplierField] || null;
}

// 区域字段映射配置
const sectorFieldMap: Record<string, { cards: string; niuType: string }> = {
    'tian': { cards: 'tianCards', niuType: 'tian_niu_type' },
    'di': { cards: 'diCards', niuType: 'di_niu_type' },
    'xuan': { cards: 'xuanCards', niuType: 'xuan_niu_type' },
    'huang': { cards: 'huangCards', niuType: 'huang_niu_type' }
};

// 获取指定区域的卡牌
function getCardsForSector(row: any, sector: string) {
    if (!row) return [];
    const fieldName = sectorFieldMap[sector]?.cards;
    return fieldName ? (row[fieldName] || []) : [];
}

// 获取指定区域的牛牛类型
function getNiuTypeForSector(row: any, sector: string): number {
    if (!row) return 0;
    const fieldName = sectorFieldMap[sector]?.niuType;
    return fieldName ? (row[fieldName] || 0) : 0;
}

// 检查区域是否在获胜区域列表中
function isWinningSector(row: any, sector: string): boolean {
    if (!row || !row.winningSectors) return false;
    return row.winningSectors.includes(sector);
}

// 检查区域是否输了（不在获胜列表中）
function isLosingSector(row: any, sector: string): boolean {
    if (!row || !row.winningSectors) return false;
    // 只要有winningSectors数据，不在列表中的就是输了
    return !row.winningSectors.includes(sector);
}

// 查找组成"牛"的3张牌索引（和为10的倍数）
function findNiuIndices(cards: any[]): number[] {
    if (!cards || cards.length < 5) return [];
    
    // 遍历所有 C(5,3)=10 种组合
    for (let i = 0; i < 3; i++) {
        for (let j = i + 1; j < 4; j++) {
            for (let k = j + 1; k < 5; k++) {
                const sum = (cards[i]?.value || 0) + (cards[j]?.value || 0) + (cards[k]?.value || 0);
                if (sum % 10 === 0) {
                    return [i, j, k];
                }
            }
        }
    }
    return []; // 无牛
}

// 将卡牌排序：组成"牛"的3张牌放前面，其余2张放后面
function sortCardsForNiu(cards: any[]): any[] {
    if (!cards || cards.length < 5) return cards || [];
    
    const niuIndices = findNiuIndices(cards);
    
    // 无牛时保持原顺序
    if (niuIndices.length === 0) return cards;
    
    // 有牛时，将牛牌放前面
    const niuCards: any[] = [];
    const otherCards: any[] = [];
    
    cards.forEach((card, index) => {
        if (niuIndices.includes(index)) {
            niuCards.push(card);
        } else {
            otherCards.push(card);
        }
    });
    
    return [...niuCards, ...otherCards];
}

// 判断卡牌是否有牛
function hasNiu(cards: any[]): boolean {
    return findNiuIndices(cards).length === 3;
}
</script>

<style lang="scss" scoped>
.gray-box {
    // background: rgba(32, 42, 57, 1);
    background-color: #161f2c; // 与窗口其它元素颜色一致
    padding: 12px;
    border-radius: 8px;
}

// 更紧凑的卡片行样式
.cards-row-compact {
    position: relative;
    display: flex;
    justify-content: center;
    height: 60px; // 增加高度容纳上移的牌
    width: 120px;
    margin: 20px auto 10px auto;
    
    :deep(.card) {
        position: absolute;
        transform: translateX(-50%);
        top: 10px; // 默认位置
    }
    
    // 有牛时前3张牌上移10px
    :deep(.card.niu-card-raised) {
        top: 0;
    }
    
    /* 卡牌位置样式 - 使用 px 定位 */
    :deep(.pocker-img0) {
        left: calc(50% - 32px);
    }
    :deep(.pocker-img1) {
        left: calc(50% - 16px);
    }
    :deep(.pocker-img2) {
        left: 50%;
    }
    :deep(.pocker-img3) {
        left: calc(50% + 16px);
    }
    :deep(.pocker-img4) {
        left: calc(50% + 32px);
    }
}

/* 游戏规则页面强制显示扑克牌正面 */
.rules-face-up {
    :deep(.front) {
        transform: rotateY(0deg) !important; /* 强制显示正面 */
    }
    :deep(.back) {
        transform: rotateY(180deg) !important; /* 强制隐藏背面 */
    }
}

// 区域信息列的样式
.td-area {
    vertical-align: middle;
    max-width: 100px;
}

.area-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

// 获胜标签样式
.winner-tag {
    display: inline-block;
    background-color: rgba(251, 191, 36, 0.1);
    border: 1px solid rgba(251, 191, 36, 0.4);
    color: #fbbf24;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    margin-right: 4px;
    margin-bottom: 4px;
}

// 结果列的样式
.td-result {
    vertical-align: middle;
    text-align: center;
    width: 80px;
}

// 牌型结果样式
.niu-type-result {
    font-size: 14px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 4px;
    display: inline-block;
    margin-bottom: 4px;
}

// 获胜结果颜色
.winning-result {
    border: 1px solid rgba(251, 191, 36, 0.4);
    box-shadow: 0 0 5px rgba(251, 191, 36, 0.2);
}

// 倍率标签样式
.multiplier-tag {
    font-size: 12px;
    font-weight: 500;
    color: #10b981;
}

// 特殊牌型（牛牛及以上）
.special-niu {
    background-color: rgba(220, 38, 38, 0.1);
    color: #ef4444;
}

// 高牌型（牛七-牛九）
.high-niu {
    background-color: rgba(251, 191, 36, 0.1);
    color: #f59e0b;
}

// 中牌型（牛四-牛六）
.medium-niu {
    background-color: rgba(59, 130, 246, 0.1);
    color: #3b82f6;
}

// 低牌型（无牛-牛三）
.low-niu {
    background-color: rgba(147, 172, 211, 0.1);
    color: #93acdb;
}

// 获胜行的背景色
:deep(.winning-row) {
    background-color: rgba(251, 191, 36, 0.03);
}

// 空数据提示
.no-data-pic {
    width: 80px;
    height: 80px;
    margin: 20px auto 10px;
    display: block;
}

.no-data-message {
    text-align: center;
    color: #93acdb;
    font-size: 14px;
}

// 牌区域的整体容器
.main-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
}

// 庄家牌区
.banker-area {
    width: 100%;
    max-width: 280px;
    background-color: rgba(30, 41, 59, 0.7);
    border: 1px solid rgba(255, 255, 255, 0.1);
}

// 下注区域的容器
.betting-areas-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    width: 100%;
    max-width: 280px;
}

// 每个区域的容器
.area-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 4px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background-color: rgba(30, 41, 59, 0.5);
    transition: all 0.2s ease;
}

// 获胜区域样式
.winning-area {
    border-color: rgba(251, 191, 36, 0.5) !important;
    background-color: rgba(251, 191, 36, 0.05) !important;
    box-shadow: 0 0 8px rgba(251, 191, 36, 0.3);
}

// 区域标题
.area-title {
    font-size: 11px;
    font-weight: 500;
    color: #93acdb;
    margin-bottom: 4px;
}

// 牌行
.cards-row {
    display: flex;
    flex-wrap: nowrap;
    gap: 2px;
    margin-bottom: 4px;
    justify-content: center;
}

// 牌型样式
.niu-type {
    font-size: 10px;
    font-weight: 500;
    padding: 1px 4px;
    border-radius: 10px;
    margin-top: 2px;
    text-align: center;
}


.analysis {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    // align-items: center;
    flex-wrap: wrap;
    flex-direction: row;

    & > * {
        min-height: 55px; // 与临近元素等高
        padding-top: 10px;
        padding-bottom: 10px;
        flex: 1 1 40%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .title {
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        color: rgba(147, 172, 211, 1);
        margin: 0 0 5px;
    }
    .quantity {
        color: white;
        font-weight: 500;
        font-size: 16px;
        display: flex;
        align-items: center;
        img {
            width: 20px;
            margin: 0 6px 0 -3px;
        }
    }
}

.won {
    color: rgba(27, 184, 61, 1) !important;
}
.lose {
    color:  #A7B5CA;
}
.big-list {
    & > .q-table__card {
        background-color: transparent;
        box-shadow: none;
    }
    & :deep(table.q-table) {
        width: 100%;
        overflow: hidden;
        background-color: transparent;
        tr {
            // border-bottom: 0.5px solid var(--bet-corgi-color-white-12, rgba(255, 255, 255, 0.12))
            border-bottom: solid 1px rgba(255, 255, 255, 0.15);
        }
        body tr:hover {
            background-color: rgba(0, 0, 0, 0.1);
        }
        th {
            color: rgba(85, 101, 126, 1);
            font-size: 12px;
            text-align: left;
        }
        td {
            opacity: 1;
        }
        th,
        td {
            padding-left: 4px;
            padding-right: 4px;
        }
    }
    td {
        .td-inner {
            font-size: 14px;
            line-height: 14px;
            vertical-align: middle;
            display: flex;
            align-items: center;
            overflow: hidden;
            max-width: 99%;
            padding: 5px 0;
            .user-avatar,
            img {
                margin: 0 5px 0 0;
            }
            .text {
                min-width: 10px;
            }
        }
        // ↓ 触雷后支付的金额
        .loose {
            color: rgba(237, 29, 73, 1);
        }
    }
    .td-user {
        color: white;
        font-weight: 600;
        .text {
            font-size: 12px;
            & > * {
                display: block;
            }
            time {
                font-size: 11px;
                color: rgba(167, 181, 202, 1);
            }
        }
    }
    .td-profit {
        font-weight: 600;
        color: rgba(147, 172, 211, 1);
    }
    
    // 最后一个区域行不显示下边框
    .last-sector-row {
        border-bottom: none !important;
        
        td {
            border-bottom: none !important;
        }
    }
}
.no-data-message {
    min-height: 150px;
    width: 100%;
    padding: 20px;
    text-align: center;
    .no-data-pic {
        width: 165px;
        margin: 0 auto 0;
    }
    .no-data-tips {
        font-size: 14px;
        color: rgba(167, 181, 202, 1);
    }
}
</style>
